import { Table } from 'antd';
import TableColumns from './TableColumns';
import { useDocumentsPage } from 'hooks/useDocumentsPage';
import { useEffect, useRef, useState } from 'react';
import { TableRowSelection } from 'antd/es/table/interface';
import { Category, Document } from 'interfaces/documents';
import { useAppDispatch } from 'utilities/hooks';
import { BaseModalRef } from 'modals/BaseModal';
import { setDocument } from 'slices/documentSlice';
import DocumentMarkupModal from 'modals/DocumentMarkupModal';
import { useModal } from 'hooks/useModal';
import { useAccess } from 'smx-components';
import { apryseExtensions } from 'utilities/constants';
import { fetchDocument } from 'slices/documentsActions';

const BaseTableDocuments = ({
    setSelectedItems,
    selected,
    shared = false,
    deleted = false,
}: {
    setSelectedItems: (items: (Category | Document)[]) => void;
    selected: (Category | Document)[];
    shared?: boolean;
    deleted?: boolean;
}) => {
    const dispatch = useAppDispatch();
    const { openModal: openDocumentMarkupModal } = useModal();

    const { list, loading, fetchData, navigateTo } = useDocumentsPage({ isShared: shared, isDeleted: deleted });

    const columns = TableColumns({ fetchData, shared, deleted });

    const rowSelection: TableRowSelection<Document | Category> = {
        selectedRowKeys: (selected || []).map((item) => item.id),
        onChange: (newSelectedRowKeys: React.Key[]) => {
            setSelectedItems(list.filter((item) => newSelectedRowKeys.includes(item.id)));
        },
    };

    const handleCategory = (category: Category) => {
        if (!navigateTo) return;
        navigateTo(category.id);
    };

    const isAllowedEdit = useAccess(['files.all.edit', 'files.all.manage']);

    const handleDocumentOpen = async (document: Document) => {
        dispatch(setDocument(document));
        if (apryseExtensions.includes(document.extension)) {
            openDocumentMarkupModal('documentMarkupModal', {
                readonly: deleted,
            });
            return;
        } else {
            const results = await dispatch(fetchDocument(document?.id));
            const url = results.payload?.data?.url;
            if (url) {
                window.open(url, '_blank');
            }
        }
    };

    return (
        <>
            <Table<Category | Document>
                columns={columns}
                dataSource={list}
                onRow={(row) => ({
                    onClick: () => {
                        if (row.type === 'category' && !deleted) {
                            handleCategory(row as Category);
                        } else if (row.type === 'document') {
                            handleDocumentOpen(row as Document);
                        }
                    },
                })}
                loading={loading}
                pagination={false}
                rowSelection={rowSelection}
            />
        </>
    );
};

export default BaseTableDocuments;
